// Page-to-page transitions. The cross-fade itself is CSS (@view-transition in site.css); here we only
// name the product photo that was tapped, so it grows into the product page's main photo.
// The receiving half lives in the head script (it has to run before the first paint).
export function mountTransitions(doc = document) {
  let picked = null;
  doc.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="/products/"]');
    picked = a ? (a.closest('.card, .srch-row, .carry')?.querySelector('[data-vt-src] img, img') || null) : null;
  }, true);
  addEventListener('pageswap', (e) => {
    if (!e.viewTransition || !picked) return;
    const to = e.activation?.entry?.url; if (!to || !new URL(to).pathname.startsWith('/products/')) return;
    picked.style.viewTransitionName = 'pimg';
    try { sessionStorage.setItem('vt-pimg', '1'); } catch {}
    e.viewTransition.finished.finally(() => { picked.style.viewTransitionName = ''; });
  });
}
